import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

export interface SettingsState {
  themeMode: 'light' | 'dark';
  sidebarCollapsed: boolean;
  auths:any,
  activeuser:any,
  authjwk:any 
}

interface SettingsContextType extends SettingsState {
  updateSettings: (newSettings: Partial<SettingsState>) => void;
  toggleTheme: () => void;
  toggleSidebar: () => void;
  onChangeauths: (_newaus:any,_user:any,_authjwk:any) => void;
  onChangeactiveuser: (_user:any,_authjwk:any) => void;
}

const SETTINGS_KEY = 'whitelist-admin-settings';

const defaultSettings: SettingsState = {
  themeMode: 'light',
  sidebarCollapsed: false,
  auths:'',
  activeuser:'',
  authjwk:'',
};

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export const SettingsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<SettingsState>(() => {
    try {
      const saved = localStorage.getItem(SETTINGS_KEY);
      return saved ? { ...defaultSettings, ...JSON.parse(saved) } : defaultSettings;
    } catch {
      return defaultSettings;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
    } catch (error) {
      console.warn('Failed to save settings:', error);
    }
  }, [settings]);

  const updateSettings = (newSettings: Partial<SettingsState>) => {
    setSettings(prev => ({ ...prev, ...newSettings }));
  };

  const toggleTheme = () => {
    updateSettings({ themeMode: settings.themeMode === 'light' ? 'dark' : 'light' });
  };

  const toggleSidebar = () => {
    updateSettings({ sidebarCollapsed: !settings.sidebarCollapsed });
  };

    const onChangeauths = (newauths:any,newactiveuser:any,newauthjwk:any) => {
   // console.log("auths-newauths:",newauths);
   // console.log("auths-newactiveuser:",newactiveuser); 
    updateSettings({
     // ...settings,
      auths: newauths,
      activeuser: newactiveuser,
      authjwk:newauthjwk,
    });
  };

  const onChangeactiveuser = (newactiveuser:any,newauthjwk:any) => {
    updateSettings({
     // ...settings,
      activeuser: newactiveuser,
      authjwk:newauthjwk,
    });
  };

  const value: SettingsContextType = {
    ...settings,
    updateSettings,
    toggleTheme,
    toggleSidebar,
    onChangeauths,
    onChangeactiveuser,
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = (): SettingsContextType => {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export default useSettings;